module.exports = __webpack_public_path__ + "static/img/Ellipse 125.fd4bf89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 125.png
// module id = RWvL
// module chunks = 1